const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const UrlHelpers = require('components/shared/url_helpers.js');
const Currency = require('components/shared/currency.js');

const { CURRENCY_CODES, COUNTRY_CODES } = require('components/shared/constants.js');

const US_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-us';
const CA_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-ca';
const EU_RP_LABEL_IMAGE_CLASS = 'payment-setup__provider-logo--rp-eu';

function DirectCheckoutWrapper(props) {
  function checkIcon() {
    return '<span class="fa fa-check fa-li color-green"></span>';
  }

  function htmlLineItem(text) {
    return <li dangerouslySetInnerHTML={{ __html: text }} />;
  }

  function labelImageClass() {
    if (props.paymentSelection === 'EU_DC_OR_PAYPAL' || props.paymentSelection === 'PAYPAL_WITH_EU_DC_UPGRADE') {
      return EU_RP_LABEL_IMAGE_CLASS;
    }

    if (props.shopCurrency === CURRENCY_CODES.USD && props.bankCountryCode === COUNTRY_CODES.US) {
      return US_RP_LABEL_IMAGE_CLASS;
    }

    return CA_RP_LABEL_IMAGE_CLASS;
  }

  function currencySymbol() {
    return Currency.get(props.shopCurrency).symbol;
  }

  return (
    <div className="payment-setup">
      <div className={classNames('payment-setup__label payment-setup__label--dc', props.className)}>
        {props.children}
        <label htmlFor="shop-settings-dc-radio">
          <div className={classNames('payment-setup__provider-logo', labelImageClass())} />
        </label>
      </div>
      <div className="payment-setup__info">
        <ul className="fa-ul font-tiny normal">
          {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.dcPaymentMethodsHtml', { icon: checkIcon() }))}
          {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.dcPayoutsHtml', { icon: checkIcon() }))}
          {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.dcFeesHtml', { icon: checkIcon(), fee_percent: props.directCheckoutFeePercent, intl_fee_percent: props.directCheckoutIntlFeePercent, currency_symbol: currencySymbol() }))}
          {htmlLineItem(I18n.t('js.dashboard.selling.shopPolicies.dcCoveredByProtectionHtml', { icon: checkIcon(), linkOpen: `<a href='${UrlHelpers.cmsPagePath('reverb-protection')}' target='_blank' rel='noreferrer noopener'>`, linkClose: '</a>' }))}
        </ul>
      </div>
    </div>
  );
}

DirectCheckoutWrapper.defaultProps = {
  children: null,
  className: '',
};

DirectCheckoutWrapper.propTypes = {
  directCheckoutFeePercent: PropTypes.number.isRequired,
  directCheckoutIntlFeePercent: PropTypes.number.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  bankCountryCode: PropTypes.string.isRequired,
  children: PropTypes.element,
  className: PropTypes.string,
  paymentSelection: PropTypes.string.isRequired,
};

module.exports = DirectCheckoutWrapper;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_wrapper.jsx